export default __webpack_public_path__ + "static/media/answer_call.21a32828.svg";